export default __webpack_public_path__ + "static/media/brickImage.ccf16b5c.png";